<template>
  <div
    :style="{ backgroundImage: 'url(' + bg + ')', backgroundPosition: 'center' }"
  >
    <v-container grid-list-lg>
      <v-layout wrap>
        <v-flex
          v-for="(module, i) in allModules" :key="i"
          xs12
          sm6
          md4
          lg4
        >
          <v-card
            hover
            @click.native="handleClick(module)"
          >
            <v-card-media
              :src="module.image ? module.image : ''"
              height="200"
            >
              <v-container fill-height>
                <v-layout align-end>
                  <v-spacer></v-spacer>
                  <v-flex text-md-right>
                    <div v-if="isAlreadyWatched(module)">
                      <v-chip color="orange" text-color="white">
                        <strong>Completed</strong>
                        <v-icon right>star</v-icon>
                      </v-chip>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-media>

            <v-list two-line>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    <strong>{{ module.title }}</strong>
                  </v-list-tile-title>
                  <!-- <v-list-tile-sub-title>
                    {{ module.description }}
                  </v-list-tile-sub-title> -->
                  <v-list-tile-sub-title>
                    <em>by {{ module.author }}</em>
                  </v-list-tile-sub-title>
                   <v-list-tile-sub-title>
                    <span class="codes_style">{{ module.codes }}</span>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <v-card-text>
              <!--<strong>CPD Points </strong>
              <v-avatar color="primary">
                <span class="white--text title">{{ module.cpd_points }}</span>
              </v-avatar>-->
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// import { getUser } from '@/utils/token'

export default {
  data () {
    return {
      bg: require('@/assets/bg/water_6.png'),
      allModules: []
    }
  },
  methods: {
    handleClick (module) {
      this.$router.push('/module/' + module.id)
      this.addToWatchlist(module)
    },
    isAlreadyWatched (item) {
      if (this.user.user_assessment) {
        let watched = this.user.user_assessment.some((u) => Number(u.module_id) === Number(item.id))
        return watched
      }
    }
  },
  props: {
    user: {
      type: Object,
      default: () => {}
    },
    modules: {
      default: null
    },
    addToWatchlist: {
      type: Function
    }
  },
  watch: {
    modules (v) {
      this.allModules = v
    }
  }
}
</script>
<style>
.codes_style {
  margin: 20px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/dashboard/allModules.vue